import { useEffect, useState } from 'react';
import { Flex } from 'antd';

import {
  useAppSelector,
  useStatusFinderByNum,
  useUserPermissions,
} from '@Hooks/index';
import { Status } from '@Components/Base';
import { getReasonOptions } from '@Features/EmployeeSelfService/requests/ResignationRequests/store/selectors/resignationRequestSelector';
import {
  useGetResignationRequestFormQuery,
  useGetSettlementAmountMutation,
} from '@Features/EmployeeSelfService/requests/ResignationRequests/store/api/resignationRequestApiSlice';

import { getModalRecordKey } from '@Store/selectors/modalSelector';

import fieldSource from '../FieldSource';

import { EditAction, FooterActions } from './components';

import styles from './view-mobile-form.module.css';

interface RequestViewMobileFormProps {
  onEdit: (recordKey: string) => void;
  onDeleteRequest: (requestNo: string) => void;
  onSubmitRequest: (requestNo: string) => void;
  onCancelRequest: (requestNo: string) => void;
}

const RequestViewMobileForm: React.FC<RequestViewMobileFormProps> = ({
  onEdit,
  onDeleteRequest,
  onSubmitRequest,
  onCancelRequest,
}) => {
  const requestId = useAppSelector(getModalRecordKey);
  const reasonOptions = useAppSelector(getReasonOptions);
  const permissions = useUserPermissions();

  const [settlementAmount, setSettlementAmount] = useState('');

  const { findStatus } = useStatusFinderByNum('Resignation');
  const { data } = useGetResignationRequestFormQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });
  const [getSettlementAmount] = useGetSettlementAmountMutation();

  useEffect(() => {
    if (!data) {
      return;
    }

    getSettlementAmount(data.resDate)
      .unwrap()
      .then((response) => {
        setSettlementAmount(String(response));
      })
      .catch(() => {
        setSettlementAmount('');
      });
  }, [data]);

  if (!data) return null;

  const statusRequest = findStatus(data?.statusId)?.codeDesc || '';

  return (
    <Flex vertical>
      <div className={styles.viewMobileForm}>
        {fieldSource(data, reasonOptions, settlementAmount).map((item) => (
          <div className={styles.viewMobileItem} key={item.label}>
            <span>{item.label}</span>
            {item.label === 'Status' ? (
              <Status
                className={styles.viewMobileItemValue}
                text={findStatus(Number(item.value))?.codeDesc || ''}
              />
            ) : (
              <span className={styles.viewMobileItemValue}>{item.value}</span>
            )}
          </div>
        ))}
      </div>
      <EditAction handleEdit={() => onEdit(requestId)} status={statusRequest} />
      <FooterActions
        handleDeleteRequest={() => onDeleteRequest(requestId)}
        handleSubmitRequest={() => onSubmitRequest(requestId)}
        handleCancelRequest={() => onCancelRequest(requestId)}
        disabledCancelForm={!permissions.can('Cancel', 'Resignation')}
        disabledDeleteForm={!permissions.can('Delete', 'Resignation')}
        disabledSubmitForm={!permissions.can('Submit', 'Resignation')}
        status={statusRequest}
      />
    </Flex>
  );
};

export default RequestViewMobileForm;
